// Mock data for Implify homepage

export const agents = [
  {
    id: 1,
    name: "Buzz",
    role: "Research & Analysis Agent",
    department: "Research",
    image: "/images/agent-thumbs/buzz.webp",
    description: "Gathers market insights, competitor analysis, and trend reports"
  },
  {
    id: 2,
    name: "Dora",
    role: "Marketing Operations Agent",
    department: "Marketing",
    image: "/images/agent-thumbs/dora.webp",
    description: "Manages campaigns, content distribution, and performance tracking"
  },
  {
    id: 3,
    name: "Luc",
    role: "Sales Automation Agent",
    department: "Sales",
    image: "/images/agent-thumbs/luc.webp",
    description: "Handles lead qualification, outreach, and pipeline management"
  },
  {
    id: 4,
    name: "Marsi",
    role: "Finance & Operations Agent",
    department: "Finance",
    image: "/images/agent-thumbs/marsi.webp",
    description: "Processes invoices, expense tracking, and financial reports"
  },
  {
    id: 5,
    name: "Sally",
    role: "Support & Success Agent",
    department: "Support",
    image: "/images/agent-thumbs/sally.webp",
    description: "Handles customer inquiries, ticket resolution, and onboarding"
  }
];

export const outcomes = [
  {
    id: 1,
    title: "Your day plans itself",
    description: "Wake up to a prioritized schedule, meeting briefs, and action items — assembled by your team overnight.",
    involvedAgents: ["Buzz", "Sally", "Dora"]
  },
  {
    id: 2,
    title: "Nothing falls through the cracks",
    description: "Agents monitor every thread, deadline, and commitment. Follow-ups happen automatically.",
    involvedAgents: ["Luc", "Sally", "Marsi"]
  },
  {
    id: 3,
    title: "Decisions come pre-analyzed",
    description: "Every choice arrives with context, data, and recommendations from agents who've done the research.",
    involvedAgents: ["Buzz", "Marsi", "Luc"]
  },
  {
    id: 4,
    title: "Follow-ups happen automatically",
    description: "No more mental load. Agents track conversations and reach out at the right time, every time.",
    involvedAgents: ["Luc", "Dora", "Sally"]
  }
];

export const integrations = [
  { name: "Gmail", category: "Email" },
  { name: "Google Calendar", category: "Calendar" },
  { name: "Google Drive", category: "Storage" },
  { name: "Slack", category: "Communication" },
  { name: "HubSpot", category: "CRM" },
  { name: "Salesforce", category: "CRM" },
  { name: "Notion", category: "Productivity" },
  { name: "Asana", category: "Project Management" },
  { name: "Stripe", category: "Finance" },
  { name: "QuickBooks", category: "Finance" },
  { name: "Zoom", category: "Meetings" },
  { name: "Microsoft Teams", category: "Communication" }
];

// Logo URLs for integrations - using Simple Icons CDN and custom uploads
export const integrationLogos = {
  Gmail: 'https://customer-assets.emergentagent.com/job_17960a1c-04d6-4169-8132-897a1439e67d/artifacts/l0vi7qxp_gmail%20%281%29.svg',
  Slack: 'https://upload.wikimedia.org/wikipedia/commons/d/d5/Slack_icon_2019.svg',
  Notion: 'https://cdn.simpleicons.org/notion',
  HubSpot: 'https://cdn.simpleicons.org/hubspot',
  Salesforce: 'https://www.svgrepo.com/show/303235/salesforce-2-logo.svg',
  Zoom: 'https://cdn.simpleicons.org/zoom',
  Teams: 'https://customer-assets.emergentagent.com/job_17960a1c-04d6-4169-8132-897a1439e67d/artifacts/r3afcszd_teams.svg',
  Drive: 'https://customer-assets.emergentagent.com/job_17960a1c-04d6-4169-8132-897a1439e67d/artifacts/1pqog0hv_google-drive.svg',
  Calendar: 'https://customer-assets.emergentagent.com/job_17960a1c-04d6-4169-8132-897a1439e67d/artifacts/tx69cz7v_google-calendar.svg',
  Asana: 'https://cdn.simpleicons.org/asana',
  Stripe: 'https://cdn.simpleicons.org/stripe',
  QuickBooks: 'https://cdn.simpleicons.org/quickbooks',
  Dropbox: 'https://cdn.simpleicons.org/dropbox',
  Jira: 'https://cdn.simpleicons.org/jira',
  Figma: 'https://cdn.simpleicons.org/figma',
  GitHub: 'https://cdn.simpleicons.org/github',
  Linear: 'https://cdn.simpleicons.org/linear',
  Intercom: 'https://cdn.simpleicons.org/intercom',
  Zendesk: 'https://cdn.simpleicons.org/zendesk',
  Airtable: 'https://cdn.simpleicons.org/airtable',
  Monday: 'https://cdn.simpleicons.org/mondaydotcom',
  Instagram: 'https://cdn.simpleicons.org/instagram',
  LinkedIn: 'https://customer-assets.emergentagent.com/job_17960a1c-04d6-4169-8132-897a1439e67d/artifacts/ajgg07ac_linkedin.svg',
  Twitter: 'https://cdn.simpleicons.org/x',
  Outlook: 'https://customer-assets.emergentagent.com/job_17960a1c-04d6-4169-8132-897a1439e67d/artifacts/lhfllbsk_outlook.svg',
  Facebook: 'https://customer-assets.emergentagent.com/job_17960a1c-04d6-4169-8132-897a1439e67d/artifacts/lkl6pj4r_facebook.svg',
  // AI Models
  Gemini: 'https://cdn.simpleicons.org/googlegemini',
  Claude: 'https://cdn.simpleicons.org/anthropic',
  OpenAI: 'https://cdn.simpleicons.org/openai',
  DeepSeek: 'https://cdn.simpleicons.org/deepseek',
  ElevenLabs: 'https://cdn.simpleicons.org/elevenlabs',
  Perplexity: 'https://cdn.simpleicons.org/perplexity',
  HuggingFace: 'https://cdn.simpleicons.org/huggingface',
  Kling: 'https://customer-assets.emergentagent.com/job_17960a1c-04d6-4169-8132-897a1439e67d/artifacts/paqqacck_kling-ai-icon.svg',
};

// White version logos for dark backgrounds (revolving icons) - keeping for fallback
export const integrationLogosWhite = {
  Gmail: 'https://cdn.simpleicons.org/gmail/white',
  Slack: 'https://cdn.simpleicons.org/slack/white',
  Notion: 'https://cdn.simpleicons.org/notion/white',
  HubSpot: 'https://cdn.simpleicons.org/hubspot/white',
  Salesforce: 'https://cdn.simpleicons.org/salesforce/white',
  Zoom: 'https://cdn.simpleicons.org/zoom/white',
  Teams: 'https://cdn.simpleicons.org/microsoftteams/white',
  Stripe: 'https://cdn.simpleicons.org/stripe/white',
  Instagram: 'https://cdn.simpleicons.org/instagram/white',
  Drive: 'https://cdn.simpleicons.org/googledrive/white',
  Outlook: 'https://cdn.simpleicons.org/microsoftoutlook/white',
};

export const useCases = [
  {
    id: "founders",
    title: "Founders",
    description: "Run your startup without burning out",
    outcomes: [
      "Daily exec summaries across all departments",
      "Investor updates drafted automatically",
      "Hiring pipeline managed end-to-end",
      "Financial reports ready when you need them"
    ]
  },
  {
    id: "marketing",
    title: "Marketing",
    description: "Ship campaigns without the coordination chaos",
    outcomes: [
      "Content calendar managed and executed",
      "Campaign performance tracked and reported",
      "Social media scheduled and monitored",
      "Lead nurturing automated across channels"
    ]
  },
  {
    id: "sales",
    title: "Sales",
    description: "Close more deals with less manual work",
    outcomes: [
      "Leads qualified and prioritized automatically",
      "Follow-ups sent at optimal times",
      "CRM updated in real-time",
      "Deal insights surfaced before every call"
    ]
  },
  {
    id: "ops",
    title: "Ops & Finance",
    description: "Keep operations running smoothly",
    outcomes: [
      "Invoices processed and tracked",
      "Expense reports generated automatically",
      "Vendor communications managed",
      "Budget tracking and alerts"
    ]
  },
  {
    id: "solo",
    title: "Solo Professionals",
    description: "Work like you have a full team",
    outcomes: [
      "Client communications handled professionally",
      "Projects tracked and delivered on time",
      "Administrative tasks done automatically",
      "Personal productivity optimized daily"
    ]
  }
];

export const collaborationSteps = [
  {
    id: 1,
    title: "Task Handoffs",
    description: "Implify agents are designed to think and act. Implify agents also interact with each other to feed off each others skillsets to deliver outcomes that drive true business results.",
    image: "/images/collaboration/task-handoffs.webp"
  },
  {
    id: 2,
    title: "Parallel Execution",
    description: "Implify agents understand the importance of each task and outcomes. To maximize outcomes Implify agents collaborate and work together on complex tasks while maintaining context so nothing falls off the cracks.",
    image: "/images/collaboration/parallel-execution.webp"
  },
  {
    id: 3,
    title: "Review & Merge",
    description: "Each agent handover is cross-referenced with the initial request and the context shared before merged into original task. All too ensure Implify adds more value and drives true business outcomes.",
    image: "/images/collaboration/review-merge.webp"
  },
  {
    id: 4,
    title: "Delivery",
    description: "Implify agents constantly work in the background even when you are unable to deliver important documents, handovers from other departments, or keeping you upto date on your emails.",
    image: "/images/collaboration/delivery.webp"
  }
];
